const commonStyle = {
  primaryColor: '#0070E0',
  dimPrimary: (index) => `rgba(0,112,224,${index})`,
  secondaryColor: '#1b1a1a',
  title: '#b4d0e7',
  input: {
    width: 400
  }
};

export default commonStyle;
